import React, { useContext, useMemo, useState, useEffect } from "react";
import { InfoContext } from "./InfoContext";
import Matchup from "./Matchup";
import LoadingCircle from "./LoadingCircle";

const MatchupList: React.FC = () => {
  const { isLoading, returnNLastMatches, getTeamById, teams, seasons } =
    useContext(InfoContext);

  const [maxMatches, setMaxMatches] = useState<number>(1);

  useEffect(() => {
    const handleResize = () => {
      const screenWidth = document.getElementById("matchup")?.offsetWidth ?? 0;
      const possibleMatches = Math.floor(screenWidth / 150);
      setMaxMatches(Math.max(1, possibleMatches));
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const lastMatches = useMemo(() => {
    return returnNLastMatches(maxMatches);
  }, [isLoading, teams, seasons, returnNLastMatches, maxMatches]);

  if (isLoading) {
    return (
      <div className="flex flex-col justify-center items-center py-10 w-full h-full text-white bg-gradient-to-r from-blue-750 to-blue-850">
        <LoadingCircle />
      </div>
    );
  }

  return (
    <div className="w-full">
      <div className="flex justify-around gap-2 items-stretch w-full">
        {lastMatches.map((match) => {
          const finalResult = match.results.find((res) => res.is_final);
          const homeTeam = getTeamById(match.home_id);
          const guestTeam = getTeamById(match.guest_id);

          if (!finalResult || !homeTeam || !guestTeam) {
            return null;
          }

          return (
            <Matchup
              key={match.id}
              team1={homeTeam.name}
              team2={guestTeam.name}
              score1={finalResult.score_home}
              score2={finalResult.score_guest}
              team1Logo={homeTeam.logo_url}
              team2Logo={guestTeam.logo_url}
              date={match.date}
            />
          );
        })}
      </div>
    </div>
  );
};

export default MatchupList;
